// ======= KONFIGURASI UTAMA =======
// Ganti URL di bawah dengan URL checkout eksternal Anda
export const CHECKOUT_URL = "https://hotaro.online/form/gp1bln";

export const BRAND = "HotaroDigital";

export const PRODUCT = {
  name: "Google Gemini Pro 18 Bulan",
  value: 79000,
  priceNormal: 5562000,
  pricePromo: 79000,
  priceNormalLabel: "Rp5.562.000",
  pricePromoLabel: "Rp79.000",
};

export const CAPCUT = {
  name: "CapCut Pro 1 Bulan",
  value: 59000,
  checkoutUrl: "https://hotarodigital.store/form/cc-pro-1-bulan",
  priceNormalLabel: "Rp149.000",
  pricePromoLabel: "Rp59.000",
};

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/26ca54a1-fbfa-45ba-95cc-df797b6a6ee6/images/ece2d4ca902b94ecd83077dc559e160f2c92cb94cd8db866668bd0eb7e363d4a.jpeg";

export const MASCOT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/26ca54a1-fbfa-45ba-95cc-df797b6a6ee6/images/3fddb6877f561cde2133d5748ff7ce880d5219ac948a96308353c0b0c3fb07c6.jpeg";
